var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  viewBox: "0 0 17 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#edit-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.087 1.34c.853-.786 2.07-.786 2.924 0l2.314 2.392c.852.786.852 2.06 0 2.846l-9.866 9.917c-.365.28-.609.47-1.096.549l-2.923.608c-.73.134-1.34-.073-1.827-.55-.487-.477-.73-1.161-.609-1.823l.609-2.998c.122-.388.244-.744.609-1.024l9.865-9.916ZM2.44 13.538l.122-.532 2.07 2.132-.487.108-2.192.435.487-2.143Zm3.776.306-2.436-2.39 7.307-7.266 1.462-1.424.974.969.488.455.974.968-1.462 1.423-7.307 7.265Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "edit-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h17v18H0z"
})))));
export { SvgEditIcon as ReactComponent };
export default __webpack_public_path__ + "images/edit-icon.svg";